import React, { useEffect, useRef, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import './DropdownMenu.scss'
const rootClassName = 'component-dropdown-menu'

interface DropdownMenuProps {
  opened?: boolean
  setOpened: (evt?: any) => void
  content?: React.ReactNode
  closeOnOutClick?: boolean
  closeOnEsc?: boolean
  className?: string
  children?: any
}

export default function DropdownMenu(props: DropdownMenuProps) {
  const [id] = useState(`${rootClassName}${getUniqueKey()}`)
  const [inter, setInter] = useState<any>(null)
  const interRef = useRef(inter)
  interRef.current = inter
  // Position
  useEffect(() => {
    const current = interRef.current
    if (current) {
      clearInterval(current)
      setInter(null)
    }
    const position = () => {
      const painel = document.querySelector(
        `#${id} .${rootClassName}-panel`
      ) as HTMLElement
      if (!painel) return
      const trigger = document.querySelector(
        `#${id} .${rootClassName}-children > *`
      ) as HTMLElement
      const bound = trigger.getBoundingClientRect()
      const pontoCentralX = bound.x + bound.width / 2
      const pontoCentralY = bound.y + bound.height / 2
      const windowHeight = window.innerHeight
      const windowWidth = window.innerWidth
      if (pontoCentralX < windowWidth / 2) {
        if (pontoCentralY < windowHeight / 2) {
          painel.style.left = `${bound.x}px`
          painel.style.top = `${bound.y + bound.height}px`
        } else {
          painel.style.left = `${bound.x}px`
          painel.style.top = `${
            bound.y - painel.getBoundingClientRect().height
          }px`
        }
      } else {
        if (pontoCentralY < windowHeight / 2) {
          painel.style.right = `${windowWidth - bound.x - bound.width}px`
          painel.style.top = `${bound.y + bound.height}px`
        } else {
          painel.style.right = `${windowWidth - bound.x - bound.width}px`
          painel.style.top = `${
            bound.y - painel.getBoundingClientRect().height
          }px`
        }
      }
    }
    if (props.opened) {
      position()
      const inter = setInterval(position, 100)
      setInter(inter)
    }
    return () => {
      if (interRef.current) {
        clearInterval(interRef.current)
        setInter(null)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opened])

  // OnOutClick
  useEffect(() => {
    const onHandleClick = (evt: any) => {
      if (evt.path) {
        if (
          document.querySelector(
            `#${id} .${rootClassName}-panel-fade-enter-done`
          ) &&
          !evt.path.includes(document.querySelector(`#${id}`))
        )
          props.setOpened(false)
      } else {
        // FIREFOX
        let aux = evt.target
        let deveFechar = true
        while (aux && aux.id !== 'root') {
          if (
            aux &&
            aux.id &&
            aux.id === id &&
            aux.classList.contains(`${rootClassName}`)
          ) {
            deveFechar = false
            break
          }
          aux = aux.parentElement
        }
        if (deveFechar) {
          props.setOpened(false)
        }
      }
    }
    const onEscPress = (evt: any) => {
      if (evt.key === 'Escape') {
        props.setOpened(false)
      }
    }

    if (props.closeOnOutClick) {
      if (props.opened) {
        document.addEventListener('mousedown', onHandleClick)
      } else {
        document.removeEventListener('mousedown', onHandleClick)
      }
    }
    if (props.closeOnEsc) {
      if (props.opened) {
        document.addEventListener('keyup', onEscPress)
      } else {
        document.removeEventListener('keyup', onEscPress)
      }
    }
    return () => {
      document.removeEventListener('click', onHandleClick)
      document.removeEventListener('keyup', onEscPress)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opened])

  const getProps = () => {
    const p: any = {
      ...props,
      id: id,
      className: getMergedClassNames([rootClassName, props.className || ''])
    }
    delete p.opened
    delete p.setOpened
    delete p.content
    delete p.closeOnOutClick
    delete p.closeOnEsc
    return p
  }

  return (
    <div {...getProps()}>
      <div className={`${rootClassName}-children`}>{props.children}</div>
      <CSSTransition
        in={props.opened}
        timeout={300}
        classNames={`${rootClassName}-panel-fade`}
        unmountOnExit
      >
        <div className={`${rootClassName}-panel`}>{props.content}</div>
      </CSSTransition>
    </div>
  )
}

DropdownMenu.defaultProps = {
  closeOnOutClick: true,
  closeOnEsc: true
}
